import React, { Fragment } from "react";
import purifyHTML from "../../utils/purifyHTML";

export default function Result({ Content, ImageUrl, Title, Url }) {
  return (
    <Fragment>
      <div className="container--search-result">
        <div>
          <h3 className="h3 h3--search-result">{Title}</h3>
          <div
            dangerouslySetInnerHTML={purifyHTML(Content.replace(/~/g, ""))}
          />
          <div>
            <a
              href={Url}
              dangerouslySetInnerHTML={purifyHTML(Url.replace(/\//g, "<wbr>/"))}
            />
          </div>
        </div>
        {ImageUrl && (
          <img className="image--search-result" src={ImageUrl} alt="" />
        )}
      </div>
      <hr />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Search/Result.js